import { PERMISSIONS } from "@/services/permission.js"
import { FEATURE_SETS } from "@/services/featureSet.js"

// Personnel planning is a paid add-on, so every route here carries `requiresFeatureSet` on top of its
// permission gate: the permissions say which *user* may open the page, the feature-set says whether the
// *tenant* bought the page at all. `featureSetGuard` sends anyone else to the add-on upsell, and the
// backend enforces the same feature-set on `/personnel-planning/**` (403 FEATURE_NOT_ENTITLED).
export default [
  {
    path: "/personnelplanning",
    name: "PersonnelPlanning",
    component: () => import("@/views/personnelplanning/PersonnelPlanningOverview.vue"),
    meta: {
      title: "nav.personnelplanning",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_PERSONNELPLANNING],
      requiresFeatureSet: FEATURE_SETS.PERSONNEL_PLANNING,
    },
  },
  {
    path: "/personnelplanning/create",
    name: "PersonnelPlanningCreate",
    component: () => import("@/views/personnelplanning/PersonnelPlanningCreate.vue"),
    meta: {
      title: "personnelplanning.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_PERSONNELPLANNING],
      requiresFeatureSet: FEATURE_SETS.PERSONNEL_PLANNING,
    },
  },
  {
    path: "/personnelplanning/:calendarId",
    name: "PersonnelCalendar",
    props: true,
    component: () => import("@/views/personnelplanning/PersonnelPlanningDetail.vue"),
    meta: {
      title: "nav.personnelplanning",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_PERSONNELPLANNING],
      requiresFeatureSet: FEATURE_SETS.PERSONNEL_PLANNING,
    },
  },
]
